<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom">
          <div class="left">投诉单号</div>
          <div class="right">{{item.mainComplainNumber}}</div>
        </div>
      </div>
      <div class="remark">
        <div class="titleName">不通过原因</div>
        <div class="notAccepted">
          <van-field placeholder="请输入不通过原因..." type="textarea" maxlength="200" v-model="reson" @input="change"/>
          <span class="total">{{currentTotal}}/200</span>
        </div>
      </div>
      <div class="btn">
        <div class="submit" @click="send">
          <van-button type="primary">确认</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import util from '../../../../utils/common'
    import api from '../../../../service/modules/complaintApis'
    export default {
        data () {
            return {
                currentTotal: 0,
                reson: '',
                item:util.getJsonLocal('item'),
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
            };
        },
        created () {

        },
        methods: {
            change () {
                this.currentTotal = this.reson.trim().length;
            },
            send () {
                if (this.reson.trim().length === 0) {
                    this.$Toast('请填写原因');
                    return;
                }
                const params = {
                    // data:{
                      'mainComplainNumber': util.getJsonLocal('item').mainComplainNumber,
                      'complainNumber': util.getJsonLocal('item').complainNumber,
                      'reportId': util.getJsonLocal('item').reportId,
                      'subId': util.getJsonLocal('item').subId,
                      'reason': this.reson.trim()
                    // }
                }
                api.worker.appealVerifyDisagree(params).then((res) => {
                    if (res.ret === 0) {
                        this.$Toast('操作成功');
                        this.$router.back();
                    }
                })
            }
        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  height: 100%;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .complaintInformation {
      width: 100%;
      .complaintNumber {
        display: flex;
        height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
        }
      }
      .complaintNumber {
        .right {
          color: blue;
        }
      }
    }
    .remark {
      width: 100%;
      margin-top: 20px;
      padding-bottom: 20px;
      .titleName {
        color: #aaa;
        text-align: left;
      }
      .notAccepted {
        margin-top: 14px;
        position: relative;
        .van-cell {
          font-size: 14px;
          background: #efeded;
          border-radius: 7px;
        }
        .total{
          position: absolute;
          right:6px;
          bottom:6px;
        }
      }
      .addCommandCenter {
          width: 70%;
          margin-left: 15%;
          font-size: 14px;
          height: 45px;
          line-height: 45px;
          color: #bbb;
          border: #ccc dashed 1px;
          text-align: center;
          margin-top: 15px;
      }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
    .btn {
      margin-top: 14px;
      .van-button {
        width: 100%;
        border-radius: 7px;
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
